export default __webpack_public_path__ + "static/5-7098b11777f3d47282a25fe4ec83dd0e.jpeg";